import React from 'react'
import '../../assets/css/loader.css'

const Loader = () => {
    return (
        <div className="loader">
            <div className="absCenter ">
                <div className="loaderCircle">
                    <div className="loaderCircle-anim">
                        <div className="loaderCircle-anim-bounce">
                            <div className="loaderCircle-anim-flop">
                                <div className="loaderCircle-circle"></div>
                            </div>
                        </div>
                    </div>
                    <div className="loaderCircle-floor">
                        <div className="loaderCircle-floor-shadow"></div>
                    </div>
                    <div className="loaderCircle-text">Loading...</div>
                </div>
            </div>
        </div>
    )
}

export default Loader